export const KnowledgeBaseMessages = {
  title: 'Kennisdatabase',
  links: "Gerelateerde pagina's",
};
